import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'zip_code_protection-retailer_exclusivity_post_commitment_info-view';

/**
 * Triggered when user view the post commitment exclusivity info badge on different surface
 */
export function trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoView(
  agreement_token: string,
  Origin2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { agreement_token, Origin2 },
  });
}
